import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f817ed04"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "append-homework"
}
const _hoisted_2 = { class: "append-homework__task-data task-data material-card_type_elevated" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "append-homework__title" }, "Задание", -1))
const _hoisted_4 = { class: "task-data__field field" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "task-data__field field" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "task-data__field field" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "task-data__field field" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "append-homework__submit" }

import ListSelect from '@/common/components/snedson-material-components/list-select/list-select.vue';
import TextField from '@/common/components/snedson-material-components/text-field/text-field.vue';
import DateSelector from '@/common/components/snedson-material-components/date-selector/date-selector.vue';
import customButton from '@/common/components/snedson-material-components/custom-button/custom-button.vue';
import { onMounted, reactive } from 'vue';
import {
    AppendHomeworkPageStateModel,
    DateFormat,
} from './append-homework-page.types';
import {
    getAppendHomeworkPage,
    postAppendHomeworkElement,
} from './api-methods';
import router from '@/router';
import moment from 'moment';

import messageCalloutIcon from '@/assets/icons/emojis/messageCallout.png';
import booksIcon from '@/assets/icons/emojis/books.png';
import studentIcon from '@/assets/icons/emojis/student.png';
import calendarIcon from '@/assets/icons/emojis/calendar.png';
import { AxiosError } from 'axios';
import { EmptyResponse } from '@/models/EmptyResponse';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppendHomeworkPage',
  setup(__props) {

const state = reactive<AppendHomeworkPageStateModel>(
    {} as AppendHomeworkPageStateModel
);

const onSubjectSelection = (subjectId: number | null) => {
    if (subjectId == null) {
        alert('Вы должны выбрать предмет');
        return;
    }
    state.task.subjectId = subjectId;
};

const onGroupSelection = (groupId: number | null) => {
    state.task.groupId = groupId;
};

const appendHomework = () => {
    if (!state.task.text) {
        alert('Вы не записали текст задания');
        return;
    }

    if (!state.task.subjectId) {
        alert('Вы не выбрали предемет, для которого доавбляется задание');
        return;
    }

    if (state.task.scheduledDate === moment(new Date()).format(DateFormat)) {
        alert('Вы не указали дату, на которое задана домашная работа');
        return;
    }

    postAppendHomeworkElement({
        classId: state.data.classId,
        groupId: state.task.groupId,
        subjectId: state.task.subjectId,
        scheduledDate: state.task.scheduledDate,
        taskText: state.task.text,
        additionalFilesUri: null,
    })
        .then((response) => {
            console.log(response.data.errorTextForUser);
            router.push({ name: 'sn.student.homeworks' });
        })
        .catch((reason: AxiosError<EmptyResponse>) => {
            alert(reason.response?.data.errorTextForUser);
        });
};

onMounted(() => {
    getAppendHomeworkPage().then((response) => {
        state.task = {
            text: '',
            scheduledDate: moment(new Date()).format(DateFormat),
            subjectId: null,
            groupId: null,
        };
        state.data = response.data;
    });
});

return (_ctx: any,_cache: any) => {
  return (state.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "field__icon",
              src: _unref(messageCalloutIcon)
            }, null, 8, _hoisted_5),
            _createVNode(TextField, {
              class: "field__input",
              placeholder: 'Введите текст задания',
              modelValue: state.task.text,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.task.text) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              class: "field__icon",
              src: _unref(booksIcon)
            }, null, 8, _hoisted_7),
            _createVNode(ListSelect, {
              class: "field__input",
              props: {
                        title: 'Предмет',
                        isDefaultSelectionAvaliable: true,
                        defaultSelectionTitle: 'Не выбрано',
                        menuItems: Object.entries(
                            state.data.avaliableSubjects
                        ).map(([id, title]) => ({ id: Number(id), title })),
                        selectedItemId: state.task.subjectId,
                    },
              onSelected: onSubjectSelection
            }, null, 8, ["props"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              class: "field__icon",
              src: _unref(studentIcon)
            }, null, 8, _hoisted_9),
            _createVNode(ListSelect, {
              class: "field__input",
              props: {
                        title: 'Группа класса',
                        isDefaultSelectionAvaliable: true,
                        defaultSelectionTitle: 'Весь класс',
                        menuItems: Object.entries(state.data.groupsOfClass).map(
                            ([id, title]) => ({ id: Number(id), title })
                        ),
                        selectedItemId: state.task.groupId,
                    },
              onSelected: onGroupSelection
            }, null, 8, ["props"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              class: "field__icon",
              src: _unref(calendarIcon)
            }, null, 8, _hoisted_11),
            _createVNode(DateSelector, {
              class: "field__input",
              modelValue: state.task.scheduledDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.task.scheduledDate) = $event)),
              props: {
                        setTodayAsMin: true,
                        maxDateDaysOffset: 14,
                    }
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(customButton, {
            props: {
                    iconName: 'add',
                    innerText: 'Добавить домашнее задание',
                    size: 'full',
                    type: 'filled',
                },
            onClick: appendHomework
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})